import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fee", "total"]

  static values = {
    baseAmount: Number
  }

  connect() {
    this.updateTotal()
  }

  updateTotal() {
    const valueElement = this.totalTarget.querySelector(".number-value") || this.totalTarget
    valueElement.textContent = this.formatCurrency(this.baseAmountValue + (this.hasFeeTarget ? this.parseAmount(this.feeTarget.value) : 0))
  }

  refresh() {
    const params = new FormData(this.element)

    params.delete("authenticity_token")
    params.delete("_method")

    if (this.hasFeeTarget) params.set(this.feeTarget.name, this.parseAmount(this.feeTarget.value))

    const url = new URL(this.element.action)
    url.search = new URLSearchParams(params).toString()

    window.Turbo.visit(url.toString(), { action: "replace" })
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(amount)
  }

  parseAmount(value) {
    const normalized = value.toString().replace(/[^\d.-]/g, "")
    const amount = Number.parseFloat(normalized)
    return Number.isNaN(amount) ? 0 : amount
  }
}
